import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { uiShowToastrMessage } from 'modules/ui-module';
import { oauthPortalScopesGet } from 'modules/oauthportal-module';
import {
  copyTextToClipboard,
  stopEvent,
  getClientData
} from 'lib/utility-functions';
import { meLocale } from "modules/me-module";
import moment from "moment";
import TableView from '../components/table-view';
import appconfig from 'config/appconfig';

export const TableContainer = (props) => {
  const [error, setError] = useState({ name: '', showError: false });
  const [newClientList, setNewClientList] = useState([]);

  const externalProps = useSelector(getValuesFromStore);
  const dispatch = useDispatch();

  const displayToastrMessage = (toastrType, toastrMessageId, toastrParams = null) =>
    dispatch(uiShowToastrMessage(toastrType, toastrMessageId, toastrParams));

  const onCopy = (str) => (e) => {
    stopEvent(e);
    if (copyTextToClipboard(str)) {
      displayToastrMessage('success', 'copy-to-clipboard.client-id-copied');
    }
    return false;
  };

  const onChange = (e) => {
    setError({ error: {} });
    const clientId = e.target.value;
    stopEvent(e);
    setSearchValue(clientId);
  };

  const getClientStartDate = useCallback((startDate) => {
    if (startDate) {
      const lang = externalProps.meLocale ? externalProps.meLocale.split("_")[0] : "en";
      return moment(startDate).locale(lang).format("LLL");
    }
    return "";
  },[externalProps.meLocale]);

  const setPermissions = (scopeList = [], client) => {
    const permissions = {};
    let clientScopes = client && client.scopes && client.scopes.length ? [...client.scopes] : [];
    if (clientScopes.indexOf(appconfig.defaultProfileScope) < 0) {
      clientScopes.unshift(appconfig.defaultProfileScope);
    }
    const permissionsControlledByDevPortal = [];
    for(let [key, groupId] of Object.entries(appconfig.newPermissionList)) {
      let scopeListWithLocale = scopeList?.filter(
        scope =>
          scope.groupId === groupId &&
          Object.keys(scope?.description ?? {}).length === 9 &&
          Object.values(scope?.description ?? {}).every(
            val => typeof val === "string" && val.trim() !== ""
          ) &&
          !!scope?.active
      );
      permissionsControlledByDevPortal.push(...scopeListWithLocale);
      const selectedScopes = scopeListWithLocale.filter(el => clientScopes.includes(el.id));
      permissions[key] = {
        name: key,
        scopes: scopeListWithLocale,
        isGranularView: false,
        hasChildScopes: scopeListWithLocale.length > 1,
        selectedScopes: selectedScopes,
        intermediate: (selectedScopes.length > 1) && (selectedScopes.length < scopeListWithLocale.length),
      };
      if (key.toLowerCase() === 'profile') {
        if (scopeListWithLocale.indexOf(appconfig.defaultProfileScope) < 0) {
          permissions[key].scopes.unshift(appconfig.defaultProfileScope);
          permissions[key].selectedScopes.unshift(appconfig.defaultProfileScope);
        }
        permissions[key].isGranularView = true;
      }
    }
    return permissions;
  };

  useEffect(() => {
    dispatch(oauthPortalScopesGet()).then((res) => {
      const scopeList = res.payload;
      const clients = props.clientList.map(client => {
        const permissions = setPermissions(scopeList, client);

         // last stage formating
        const data = getClientData(client, permissions);
        data.clientStartDate = getClientStartDate(data.created);
        return data;
      });
      setNewClientList(clients);
    });

  },[props.clientList,getClientStartDate]);

  return (
    <TableView
      clientList={newClientList}
      hasClients={!!newClientList.length}
      onCopy={onCopy}
      onChange={onChange}
    />
  );
};

TableContainer.propTypes = {
    clientList: PropTypes.array.isRequired,
};

export const getValuesFromStore = (state) => {
  return {
    meLocale: meLocale(state),
  };
};

export default TableContainer;
